/* @flow */
import * as React from 'react';
import Row from 'components/Row.jsx';
import Link from 'components/Link.jsx';
import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import Divider from 'components/Divider.jsx';
import LinkConstants from 'constants/LinkConstants';
import UserPasswordForm from './UserPasswordForm.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import UserPersonalInfoForm from './UserPersonalInfoForm.jsx';
import PIIConsentForm from 'settings/components/PIIConsentForm.jsx';
import DeleteAccountConfirmationDialog from 'settings/components/DeleteAccountConfirmationDialog.jsx';
import BirthdateSection from './UserProfileView/BirthdateSection.jsx';
import RoleSection from './UserProfileView/RoleSection.jsx';
import AllPIIDownloadSection from './AllPIIDownloadSection.jsx';

class AccountSettingsView extends React.Component<{}> {
  handleDeletedAccount() {
    window.location = LinkConstants.MARKETING;
  }

  render() {
    const deleteAccountDialogSubtext = CurrentUser.getUser().canCreateGroups()
      ? 'You will no longer have access to your classes or participants. This action can’t be undone.'
      : 'You will no longer have access to your classes. This action can’t be undone.';

    const deleteAccountDialog = (
      <DeleteAccountConfirmationDialog
        subtext={deleteAccountDialogSubtext}
        onDeleted={this.handleDeletedAccount}
        sourceEventKey="from_delete_account_button"
        title="Are you sure you want to delete your account?"
      />
    );

    return (
      <div className="AccountSettingsView">
        <UserPersonalInfoForm />
        <Divider />
        <UserPasswordForm />
        <Divider />
        <RoleSection />
        <Divider />
        <BirthdateSection />
        <Divider />
        <PIIConsentForm />
        <Divider />
        <AllPIIDownloadSection />
        <Divider />

        <Row>
          <ModalTrigger modal={deleteAccountDialog}>
            <Button
              color="lava"
              level="secondary"
              size="xsmall"
              eventElementName="UserSettingsView-deleteAccountBtn">
              Delete account
            </Button>
          </ModalTrigger>
        </Row>
        <Link href={LinkConstants.TERMS_OF_SERVICE} target="_blank" color="thunder">
          Terms & Privacy
        </Link>
      </div>
    );
  }
}

export default AccountSettingsView;
